<app-toaster></app-toaster>
<app-loader></app-loader>
<router-outlet/>
<div class="fixed left-2 bottom-2">
  <app-responsive-helper></app-responsive-helper>
</div>

